import { render, staticRenderFns } from "./mallInvoiceApply.vue?vue&type=template&id=2833acc4&scoped=true"
import script from "./mallInvoiceApply.vue?vue&type=script&lang=js"
export * from "./mallInvoiceApply.vue?vue&type=script&lang=js"
import style0 from "./mallInvoiceApply.vue?vue&type=style&index=0&id=2833acc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2833acc4",
  null
  
)

export default component.exports